import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { atualizarStatusViagemPeloPiloto } from '../servicos/cadastroServico';
import { useNavigate } from 'react-router-dom';
import { buscarDadosViagem } from '../servicos/listagemServico';
import LoadingIndicator from '../components/LoadingIndicator'

function MapaLevandoClienteAoDestino() {
  const [dadosCliente, setDadosCliente] = useState(null);
  const navigate = useNavigate();
  const [loadingIndicator, setLoadingIndicator] = useState(true);

  const handleBuscarDadosViagem = async () => {
    console.log('! Entrou em handleBuscarDadosViagem...');
  
    const cookies = Cookies.get();
    const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;
  
    if (!dadosCookies) {
      console.warn("Dados do cliente não encontrados nos cookies!");
      navigate('/pagina-piloto-mototaxi');
      return;
    }
  
    try {
      console.log('Preparando para buscar dados da viagem....');
      const response = await buscarDadosViagem(dadosCookies);
  
      // Atualiza os cookies com os dados corretos da viagem
      const novosDadosCookies = {
        ...dadosCookies,
        dadosPiloto: {
          ...dadosCookies.dadosPiloto,
          objViagem: response.objViagem,
        }
      };
      Cookies.set('dadosCookies', JSON.stringify(novosDadosCookies), { expires: 60 });
  
      // 🔹 Verifica status da viagem
      if (response?.objViagem?.nome_status === 'VIAGEM CANCELADA PELO CLIENTE') {
        alert('Sua viagem foi cancelada pelo cliente.');
        navigate('/pagina-piloto-mototaxi');
      } else if (response?.objViagem?.nome_status === 'VIAGEM FINALIZADA') {
        navigate('/pagina-piloto-mototaxi');
      }      
  
    } catch (e) {
      console.error('Erro ao buscar os dados da viagem:', e);
    }
  };
  

  useEffect(() => {
    const buscarDados = () => {
      try {
        const cookies = Cookies.get();
        const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;

        if (!dadosCookies || !dadosCookies.dadosPiloto?.objViagem) {
          console.warn("Dados do cliente não encontrados nos cookies!");
          navigate('/pagina-piloto-mototaxi');
          return;
        }

        // Pegamos os dados do cliente a partir de objViagem
        const objViagem = dadosCookies.dadosPiloto.objViagem;
        const objUser = dadosCookies.dadosPiloto.objUser;

        setDadosCliente({
          nome: objUser.name || 'Cliente',
          endereco_origem: objViagem.descricao_endereco_origem || 'Endereço não informado',
          endereco_destino: objViagem.descricao_endereco_destino || 'Endereço não informado',
          celular: objViagem.objInternautaCliente.numero_celular_com_ddd || null
        });

      } catch (err) {
        console.error('Erro ao buscar dados do cliente:', err);
      }
    };

    buscarDados();

    // 🔹 executa handleBuscarDadosViagem a cada 5 segundos
    const interval = setInterval(() => {
      handleBuscarDadosViagem();
    }, 5000);
  
    return () => clearInterval(interval);
  }, []);


  // 🔹 Abrir rotas (1 clique, app padrão do sistema) com coordenadas
  const openRotas = () => {
    console.log('Entrou em openRotas (MapaLevandoClienteAoDestino)....');

    try {
      const cookies = Cookies.get();
      const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;

      if (!dadosCookies?.dadosPiloto?.objViagem) {
        alert('Não foi possível carregar as coordenadas.');
        return;
      }

      // Origem: posição atual do piloto
      const latOrigem = dadosCookies.dadosPiloto.objViagem.latitude_piloto;
      const lngOrigem = dadosCookies.dadosPiloto.objViagem.longitude_piloto;

      // Destino: coordenadas finais do destino
      const latDestino = dadosCookies.dadosPiloto.objViagem.latitude_destino;
      const lngDestino = dadosCookies.dadosPiloto.objViagem.longitude_destino;

      console.log('latOrigem:', latOrigem);
      console.log('lngOrigem:', lngOrigem);
      console.log('latDestino:', latDestino);
      console.log('lngDestino:', lngDestino);

      if (!latOrigem || !lngOrigem || !latDestino || !lngDestino) {
        alert('Coordenadas de origem/destino não disponíveis.');
        return;
      }

      const ua = navigator.userAgent || navigator.vendor || window.opera;

      // iOS → Apple Maps
      if (/iPad|iPhone|iPod/.test(ua)) {
        window.location.href = `http://maps.apple.com/?saddr=${latOrigem},${lngOrigem}&daddr=${latDestino},${lngDestino}&dirflg=d`;
        return;
      }

      // Android → esquema geo: aciona app padrão de mapas (Maps, Waze etc.)
      if (/Android/i.test(ua)) {
        const geoUrl = `geo:${latDestino},${lngDestino}?q=${latDestino},${lngDestino}(Destino)`;
        const fallback = setTimeout(() => {
          window.location.href = `https://www.google.com/maps/dir/?api=1&origin=${latOrigem},${lngOrigem}&destination=${latDestino},${lngDestino}&travelmode=driving`;
        }, 1200);
        window.location.href = geoUrl;
        window.addEventListener('pagehide', () => clearTimeout(fallback), { once: true });
        window.addEventListener('blur', () => clearTimeout(fallback), { once: true });
        return;
      }

      // Desktop/Outros → Google Maps Web
      window.open(
        `https://www.google.com/maps/dir/?api=1&origin=${latOrigem},${lngOrigem}&destination=${latDestino},${lngDestino}&travelmode=driving`,
        '_blank',
        'noopener,noreferrer'
      );
    } catch (err) {
      console.error('Erro ao abrir rotas:', err);
      alert('Erro ao abrir o mapa.');
    }
  };

  // Atualiza a localização do piloto nos cookies
  const atualizarLocalizacaoPiloto = () => {
    if (!navigator.geolocation) {
      console.warn('Geolocalização não suportada pelo navegador.');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;

        // Atualiza cookies
        const cookies = Cookies.get();
        const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : {};
        const novosDadosCookies = {
          ...dadosCookies,
          dadosPiloto: {
            ...dadosCookies.dadosPiloto,
            latitude,
            longitude,
            objViagem: dadosCookies.dadosPiloto?.objViagem || null,
          },
        };
        Cookies.set('dadosCookies', JSON.stringify(novosDadosCookies), { expires: 60 });
      },
      (error) => {
        console.error('Erro ao obter geolocalização: ', error);
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 5000 }
    );
  };

  useEffect(() => {
    const intervalGeo = setInterval(() => {
      atualizarLocalizacaoPiloto();
    }, 15000); // a cada 15s

    return () => clearInterval(intervalGeo);
  }, []);


  if (!dadosCliente) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Carregando...</span>
          </div>
          <p className="fw-bold fs-5">Obtendo dados do cliente...</p>
        </div>
      </div>
    );
  }

  const handleInformarQueChegamos = async () => {
    setLoadingIndicator(true);

    const cookies = Cookies.get();
    const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;

    if (!dadosCookies ) {
      console.warn("Dados do cliente não encontrados nos cookies!");
      navigate('/pagina-piloto-mototaxi');
      return;
    }

    try {
      const dadosCookiesAtualizados = JSON.parse(Cookies.get().dadosCookies);
      const respostaViagem = await atualizarStatusViagemPeloPiloto(
        dadosCookiesAtualizados,
        'VIAGEM FINALIZADA'
      );
  
      const novoObjetoViagem = respostaViagem.objViagemAlterarStatus;
      const novosDadosCookies2 = {
        ...dadosCookiesAtualizados,
        dadosPiloto: {
          ...dadosCookiesAtualizados.dadosPiloto,
          objViagem: novoObjetoViagem
        }
      };
      Cookies.set('dadosCookies', JSON.stringify(novosDadosCookies2), { expires: 60 });
  
      navigate(`/pagina-piloto-mototaxi`);

    } catch (e) {
      console.error('Erro ao finalizar a viagem:', e);
    } finally {
      setLoadingIndicator(false);
    }
  };


  return (
    <div className="container mt-5">
      <h3 className="text-center mb-4 text-primary fw-bold">
        <i className="bi bi-person me-2"></i>
        Vamo que vamo!
      </h3>

      <div className="card shadow-lg border-0 rounded-4 p-4">
        <h4 className="fw-bold text-dark mb-1">{dadosCliente.nome}</h4>
        <hr />
        <p className="mb-1"><strong>📍 Endereço Destino: </strong> {dadosCliente.endereco_destino}</p>
        <hr />

        {/* 🔹 Botão Rotas */}
        <div className="d-grid gap-2 mb-3">
          <button type="button" className="btn btn-primary btn-lg w-100" onClick={openRotas}>
            <i className="bi bi-geo-alt me-2"></i> Rotas até o Destino
          </button>
        </div>

        <button 
          className="btn btn-success btn-lg w-100 w-md-auto mt-2 mt-md-0"
          onClick={handleInformarQueChegamos}
        >
          <i className="bi bi-check-circle me-2"></i> Chegamos ao destino final !!!
        </button>
      </div>
    </div>
  );
}

export default MapaLevandoClienteAoDestino;
